export default function isInvalidQueryError(error) {
  return error.networkError?.result?.code === 'ERR_INVALID_QUERY';
}
